import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '../Icon';
var transactionTypeIcons = {
    REFUND: _jsx(Icon, { name: "faHandsHoldingDollar" }),
    PAYMENT: _jsx(Icon, { name: "faHandsHoldingDollar" }),
    CREDIT: _jsx(Icon, { name: "faCircleDollarToSlot" }),
    AUTHORIZATION: _jsx(Icon, { name: "faCircleCheck" }),
    ADJUSTMENT: _jsx(Icon, { name: "faCalculatorSimple" }),
    CASH_ADVANCE: _jsx(Icon, { name: "faWallet" }),
    PURCHASE: _jsx(Icon, { name: "falCreditCard", size: "lg" }),
    INTEREST: _jsx(Icon, { name: "faPercent" }),
    FEE: _jsx(Icon, { name: "faFileInvoiceDollar" }),
    DEFAULT: _jsx(Icon, { name: "faCircleDollar" })
};
export default transactionTypeIcons;
//# sourceMappingURL=TransactionTypeIcons.js.map